// src/components/StickyHeader.jsx
import React from 'react';
import styled from 'styled-components';

const HeaderWrapper = styled.header`
  position: fixed;
  top: 0; 
  left: 0;
  width: 100%;
  height: 90px; 
  background: rgba(23, 37, 62, 0);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 999; 
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
  /* --- ▼▼▼ أضف هذا الكود ▼▼▼ --- */
  transition: opacity 0.3s ease, visibility 0.3s ease;

  body.chat-open & {
    @media (max-width: 768px) {
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
    }
  }
  /* --- ▲▲▲ نهاية الإضافة ▲▲▲ --- */
`;

const StickyHeader = () => {
  return <HeaderWrapper />;
};

export default StickyHeader;